/*globals jQuery */
( function() {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	// MATCH ELEMENT HEIGHTS
	window.MSR.sameHeightElements = ( function( $, undefined ) {
		var config;
		
		var init = function( settings ) {
			config = {
				parent: '.same-height-group',
				target: '.same-height-target'
			};

			$.extend( config, settings );

			this.set();
		};

		var set = function() {
			var maxHeight = 0;
			var targets = $( config.parent ).find( config.target );
			targets.each( function( i, el ){
				$( el ).css( 'height', 'auto' );
				if ( $( el ).height() > maxHeight ) {
					maxHeight = $( el ).height();
				}
			} ).height( maxHeight );
		};

		return {
			init: init,
			set: set
		};
	} )( jQuery );
} )();
